// Debug 
const url_debug = 'http://localhost:52120';




export default {

    getUrl() {
        if (window.location.host.includes("localhost"))
            return url_debug

        return window.location.protocol + "//" + window.location.host
    },

    getUrlApi() {

        let url = this.getUrl();
        url += "/api"
        return url

    },

    getUrlImg() {

        let url = this.getUrl();

        return url + "/risorse/img";
    },

    getUrlUpdate() {

        let url = this.getUrl();

        if (window.location.host.includes("localhost"))
            url = ""
        else
            url += "/index.html"

        return url
    },

}